// src/api/index.js
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import { login } from './login';

console.log('VUE_APP_BASE_API:', JSON.stringify(process.env.VUE_APP_BASE_API))
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000000,
});

// 请求拦截器（可加 token）
service.interceptors.request.use(
  config => {
    // config.headers.Authorization = `Bearer ${token}`;
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.token = `${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.data?.success === false) {
      ElMessage.error(response.data.message || '请求出错');
      return Promise.reject(response.data);
    }


    if (response.data.code == '20002') {
      return ElMessageBox.prompt('请输入你的官网操作key', '登录验证', {
        showClose: false,
        confirmButtonText: '登录',
        // cancelButtonText: '取消',
        showCancelButton: false,
        inputPattern:
          /.+/,
        inputErrorMessage: '官网操作key不能为空',
        beforeClose: (action, instance, done) => {

          if (action == 'confirm') {
            // 调用接口示例 - 请根据实际需求调整API函数和参数
            login({ key: instance.inputValue })
              .then(response => {
                // ElMessage({ type: 'success', message: '接口调用成功' });
                // done();
                console.log(response);
                if (response.code == '200') {
                  // 存储token到localStorage
                  localStorage.setItem('token', response.data);
                  ElMessage({ type: 'success', message: '登录成功' });
                  // 刷新页面
                  window.location.reload();
                } else {
                  ElMessage({ type: 'error', message: '官网操作key错误' });
                }
              })
              .catch(error => {
                ElMessage({ type: 'error', message: '官网操作key错误' });
                // done();
              });
          } else {
            // done()
          }



        },
      })
        .then(({ value }) => {
          ElMessage({
            type: 'success',
            message: `Your email is:${value}`,
          })
        })
        .catch(() => {
          ElMessage({
            type: 'info',
            message: 'Input canceled',
          })
        })
    }

    return response.data;
  },
  error => {
    ElMessage.error(error.message || '网络异常');
    return Promise.reject(error);
  }
);

export default service;
